<div class="bg-th-blue mt-0 container-fluid py-2">
  <div class=" d-flex justify-content-between align-content-center">
    <i class="fa fa-arrow-left text-secondary my-auto pointer text-white" routerLink="/"></i>
    <a class=" d-flex align-items-center  text-secondary f18 my-auto text-white">
      <span> داشبورد وضعیت شارژ</span>
    </a>
  </div>
</div>

<div class="container py-4">
  <div class="filter-section mt-3">
    <div class="filter-container">
      <div class="search-box">
        <i class="fa fa-search search-icon position-absolute ms-2 top-50 translate-middle-y"></i>
        <input class="search-input form-control ps-5" placeholder="جستجو بر اساس پلاک..." [formControl]="searchKey">
      </div>
      <div class="dropdown">
        <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="sortDropdown"
          data-bs-toggle="dropdown" aria-expanded="false">
          <i [class]="'fa fa-sort-amount-' + sortDirection"></i>
          <span id="sortLabel">مرتب‌سازی</span>
        </button>
        <ul class="dropdown-menu" aria-labelledby="sortDropdown">
          <li *ngFor="let option of sortOptions">
            <a class="dropdown-item pointer" (click)="toggleSort(option.value)">
              <span>{{ option.label }}</span>
              <span class="float-end badge" [id]="'badge-' + option.value"></span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- خودرو‌ها -->
  <div class="row g-4">
    <div class="col-12 col-sm-6 col-lg-4" *ngFor="let vehicle of filteredVehicles;">
      <div class="vehicle-card" (click)="openCarInformation(vehicle)">
        <div class="vehicle-image">
          <img src="../../../assets/Img/Changan EV460.png" [alt]="vehicle.strFullName">
          <span class="vehicle-plate">{{ formatedPlate(vehicle.strVehicleNo) }}</span>
          <span class="charge-soc" [class]="'priority-' + vehicle.ChargePriority">
            <i class="fa fa-bolt fa-lg"></i>
            {{ getChargeStatus(vehicle.ChargePriority) }}
          </span>
        </div>
        <!-- اطلاعات -->
        <div class="vehicle-info">
          <h5 class="updated-time">
            <i class="fa fa-history" aria-hidden="true"></i>
            {{ vehicle.ReportTime | date:'yyyy/MM/dd - HH:mm' }}
          </h5>
          <div class="info-grid">
            <!-- Current Odometer -->
            <div class="info-item">
              <div class="info-label">کیلومتر فعلی</div>
              <div class="info-value">
                {{ vehicle.CurrentOdometer | number }}
                <span class="info-unit">km</span>
              </div>
            </div>
            <!-- Estimated Range -->
            <div class="info-item">
              <div class="info-label">برد تخمینی</div>
              <div class="info-value">
                {{ vehicle.EstimatedRange | number }}
                <span class="info-unit">km</span>
              </div>
            </div>
            <!-- SOC -->
            <div class="info-item">
              <div class="info-label">شارژ باتری (SOC)</div>
              <div class="info-value">
                <div class="progress-bar-container">
                  <div class="progress-bar">
                    <div class="progress-fill" [style.width.%]="vehicle.SOC"></div>
                  </div>
                  <span class="progress-text">{{ vehicle.SOC?.toFixed(1) }}%</span>
                </div>
              </div>
            </div>
            <!-- SOH -->
            <div class="info-item">
              <div class="info-label">سلامت باتری (SOH)</div>
              <div class="info-value">
                <div class="progress-bar-container">
                  <div class="progress-bar soh">
                    <div class="progress-fill soh" [style.width.%]="vehicle.SOH"></div>
                  </div>
                  <span class="progress-text">{{ vehicle.SOH?.toFixed(1) }}%</span>
                </div>
              </div>
            </div>
            <!-- Last Charge Date -->
            <div class="info-item">
              <div class="info-label">زمان دریافت شارژ</div>
              <div class="info-value time">
                {{ (vehicle.LastChargeTime ? (vehicle.LastChargeTime| date:'HH:mm') : '-') }}
                <span class="info-unit">
                  {{ vehicle.LastChargeTime | date:'yyyy/MM/dd' }}
                </span>
              </div>
            </div>
            <!-- Last Charge SOC -->
            <div class="info-item">
              <div class="info-label">سطح شارژ دریافتی</div>
              <div class="info-value">
                {{ vehicle.LastChargeSOC ? vehicle.LastChargeSOC : '-' }}
                <span class="info-unit">{{vehicle.LastChargeSOC ? '%' : ''}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>